import { Directive } from '@angular/core';
import { DataBaseComponent } from '@shared/directives/data-base.component';
import { AnswerOption } from '@shared/components/question-box/question-box.component';
import {
  BoatConstructionType,
  BoatConstructionTypeTranslocoMap,
  BoatType,
  BoatMastMaterialOptions
} from '@backend/models';

@Directive()
export class BoatDataBaseComponent extends DataBaseComponent {
  boatTypeAnswerOptions: AnswerOption<BoatType>[] = [
    { title: 'bvs.motoryachtMotorboot', id: BoatType.MotorbootMotoryacht, value: BoatType.MotorbootMotoryacht },
    { title: 'bvs.segelyachtSegelboot', id: BoatType.SegelbootSegelyacht, value: BoatType.SegelbootSegelyacht }
  ];

  mastMaterialValues = BoatMastMaterialOptions.map(opt => opt);

  boatConstructionTypeOptions: AnswerOption<BoatConstructionType>[] = [
    {
      title: BoatConstructionTypeTranslocoMap[BoatConstructionType.Gleiter],
      id: BoatConstructionType.Gleiter,
      value: BoatConstructionType.Gleiter
    },
    {
      title: BoatConstructionTypeTranslocoMap[BoatConstructionType.Verdraenger],
      id: BoatConstructionType.Verdraenger,
      value: BoatConstructionType.Verdraenger
    }
  ];
}
